import { SIGN_IN_USER, SIGN_OUT_USER } from "./authConstants";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../../app/config/firebase";
import { APP_LOADED } from "../../app/async/asyncReducer";
import { onSnapshot } from "firebase/firestore";
import {
  dataFromSnapshot,
  getUser,
} from "../../app/firestore/firestoreService";
import { listenToCurrentUser } from "../users/userActions";

export function signInUser(user) {
  return {
    type: SIGN_IN_USER,
    payload: user,
  };
}

export function verifyAuth() {
  return function (dispatch) {
    return onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch(signInUser(user));
        const userRef = getUser(user.uid);
        onSnapshot(userRef, (snapshot) => {
          dispatch(listenToCurrentUser(dataFromSnapshot(snapshot)));
          dispatch({ type: APP_LOADED });
        });
      } else {
        dispatch(signOutUser());
        dispatch({ type: APP_LOADED });
      }
    });
  };
}

export function signOutUser() {
  return {
    type: SIGN_OUT_USER,
  };
}
